import { IOptionsGroups } from 'features/ApartmentList/types';

export const getPreparedFurnishingTabs = (data: IOptionsGroups) => {
  const { optionGroups } = data;
  return optionGroups.map(option => option);
};
